<h1 mat-dialog-title i18n>
	Associate legals to <small class="align-top">- {{dialogData.appKey.name}}</small>
</h1>
<form [formGroup]="formInputs" (ngSubmit)="onFormSubmit()">
	<div mat-dialog-content class="main-content">
		<div class="row align-items-center">
			<mat-form-field appearance="standard" class="col-12 col-md-auto app-key-legal-select" floatLabel="always">
				<mat-label i18n>Legals</mat-label>
				<mat-select #legalsSelect formControlName="legals" placeholder="{{ selectedLegals.length }} selected">
					<mat-select-trigger i18n>{{selectedLegals.length}} Selected</mat-select-trigger>

					<div class="app-key-legal-select__all" mat-menu-item (click)="selectAll()" *ngIf="legals.length > 0">Select All</div>
					<mat-divider></mat-divider>

					<mat-option *ngIf="legals.length === 0" i18n>All selected</mat-option>
					<mat-option
						*ngFor="let legal of legals"
						[value]="legal"
					>{{legal.displayName}}</mat-option>
				</mat-select>
			</mat-form-field>

			<div class="col-12 col-md-auto">
				<button
					type="button"
					(click)="removeAllLegals()"
					title="Deselect All"
					i18n-title
					[disabled]="selectedLegals.length === 0"
					mat-flat-button
					color="warn"
					i18n
					class="w-100"
				>Deselect All</button>
			</div>
		</div>

		<div class="row mb-4" [ngClass]="{'hide-element': selectedLegals.length === 0 }">
			<div class="col">
				<div class="table-responsive">
					<table
						mat-table
						matSort
						[dataSource]="selectedLegals"
						class="w-100"
						multiTemplateDataRows
						aria-label="List of selected legal documents"
					>
						<ng-container matColumnDef="displayName">
							<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n>Name</th>
							<td mat-cell *matCellDef="let row" class="text-nowrap">
								<button i18n-title title="View legal" type="button" class="button-link" (click)="viewTerm(row)">
									{{ row.displayName }}
								</button>
							</td>
						</ng-container>

						<ng-container matColumnDef="alias">
							<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n>Alias</th>
							<td mat-cell *matCellDef="let row" class="text-nowrap">
								<span *ngIf="row?.alias">{{row.alias}}</span>
								<span *ngIf="!row?.alias" i18n>N/A</span>
							</td>
						</ng-container>

						<ng-container matColumnDef="version">
							<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef i18n>Version</th>
							<td mat-cell *matCellDef="let row" class="text-nowrap">
								{{row.documents[row.activeVersion].displayVersion}}
							</td>
						</ng-container>

						<ng-container matColumnDef="action" [stickyEnd]="true">
							<th scope="col" mat-header-cell *matHeaderCellDef class="text-center"></th>
							<td mat-cell *matCellDef="let row; let i = dataIndex" class="actions text-center no-wrap">
								<button
									mat-icon-button
									type="button"
									(click)="removeLegal(row)"
									title="Remove"
									i18n-title
									class="text-danger"
								><mat-icon>delete</mat-icon></button>
							</td>
						</ng-container>

						<tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
						<tr
							mat-row
							*matRowDef="let row; columns: tableColumns; let i = dataIndex;"
						></tr>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div mat-dialog-actions class="row px-1 mb-0">
		<div class="col text-center">
			<button class="w-100" mat-flat-button mat-dialog-close i18n type="button">Cancel</button>
		</div>
		<div class="col text-center">
			<button
			class="w-100"
			[disabled]="selectedLegals.length === 0"
			type="submit"
			mat-flat-button
			color="primary"
			i18n
			>Save</button>
		</div>
	</div>
</form>
